module.exports = __webpack_public_path__ + "img/icon-active.9f68de56.svg";